import {
  AccessibilityNew,
  BuildOutlined,
  FitnessCenterOutlined,
  LocalDiningOutlined,
  LocalGroceryStoreOutlined,
  SchoolOutlined,
  ShoppingBagOutlined,
  SpaOutlined,
  SportsEsportsOutlined,
  WorkOutlineOutlined,
} from '@mui/icons-material';

import { Industry } from '@features/industry';

export const industries: Industry[] = [
  {
    title: 'Restaurant & Hospitality',
    Icon: LocalDiningOutlined,
    industryId: 2,
  },
  { title: 'Cannabis', Icon: SpaOutlined, industryId: 102 },
  { title: 'Education & Childcare', Icon: SchoolOutlined, industryId: 4 },
  {
    title: 'C-Store & Grocery',
    Icon: LocalGroceryStoreOutlined,
    industryId: 3,
  },
  {
    title: 'Retail & Customer Service',
    Icon: ShoppingBagOutlined,
    industryId: 1,
  },
  {
    title: 'Fitness, Beauty, Health & Wellness',
    Icon: FitnessCenterOutlined,
    industryId: 7,
  },
  {
    title: 'Construction & Specialized Labor',
    Icon: BuildOutlined,
    industryId: 6,
  },
  {
    title: 'Recreation & Entertainment',
    Icon: SportsEsportsOutlined,
    industryId: 8,
  },
  {
    title: 'Not for Profit',
    Icon: AccessibilityNew,
    industryId: 101,
  },
  { title: 'Other Industries', Icon: WorkOutlineOutlined, industryId: 100 },
];
